import { useState } from 'react';
import cc from 'classcat';

import { generateLabel } from '#src/lib/extract-text-children.js';
import { useComponents } from '#src/lib/component-mappings';

import { useLastToast } from '../../hooks';
import { gameFaqUrl, gameRulesUrl } from '../../lib/url-builders';
import { flattenImageAsset } from '../../lib/contentful/selectors';
import { CloudinaryImage } from '../CloudinaryImage';
import Container from '../Container';
import BaseLink from '../Link';
import Menu from '../Menu';
import { ToastWithIcon } from '../ToastWithIcon';
import { trackEvent } from '../../lib/analytics';

import menuIcon from './hamburg.svg';
import styles from './styles.module.scss';

function Link({ onClick, ...props }) {
  const handleClick = (e) => {
    try {
      const label = generateLabel(props.children) || props.to;
      trackEvent(`Header Link Clicked - ${label}`, {
        link: props.to,
      });
    } catch (err) {
      console.error(err);
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <BaseLink {...props} onClick={handleClick} />;
}

export default function Header({
  className,
  corporatePrimaryMenu,
  dynamicBackground,
  isCorporate,
  logo,
  primaryMenu: defaultPrimaryMenu,
  secondaryMenu,
  theme,
}) {
  const { loginStatus: LoginStatus } = useComponents();
  const [menuOpen, setMenuOpen] = useState(false);
  const primaryMenu = isCorporate ? corporatePrimaryMenu : defaultPrimaryMenu;
  const toast = useLastToast('header');

  return (
    <Container
      className={cc([
        styles.container,
        styles[theme],
        className,
        {
          [styles.corporate]: isCorporate,
        },
      ])}
      outerClassName={cc([{ [styles.defaultBackground]: !!dynamicBackground }])}
    >
      {!!toast && <ToastWithIcon {...toast} />}
      <header className={styles.header} role="banner">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={styles.menuButton}
        >
          <img
            src={menuIcon}
            alt="A menu icon that looks like 3 stacked lines."
            className={styles.menuIcon}
          />
        </button>
        <Link
          to={`/${isCorporate || theme == 'waybetter' ? '' : theme}`}
          className={styles.logoContainer}
        >
          <CloudinaryImage
            {...flattenImageAsset(logo)}
            className={styles.logo}
          />
        </Link>
        <Menu
          className={styles.menu}
          primaryItems={primaryMenu}
          secondaryItems={secondaryMenu}
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
        />
        <div className={styles.product}>
          <div className={styles.productLinks}>
            <Link theme={theme} to={gameFaqUrl({ product: theme })}>
              FAQ
            </Link>
            <Link theme={theme} to={gameRulesUrl({ product: theme })}>
              Rules
            </Link>
          </div>
          <LoginStatus product={theme} className={styles.login} />
        </div>
      </header>
    </Container>
  );
}
